export const EXPENSE_CATEGORIES = [
  'Advertising & Marketing',
  'Inventory',
  'Freight & Logistics',
  'Professional Services',
  'Software & Subscriptions',
  'Rent & Facilities',
  'Utilities & Comms',
  'Travel & Entertainment',
  'Office Supplies',
  'Insurance',
  'Government & Compliance',
  'Other',
];
